define('views/modules/setting/business/modals/payment-expired-group-modal',[
    // Libs
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'toastr',
    // services
    'services/user',
    'services/i18n',
    'services/api',
    // views
    'views/parts/modal/modal',
    // templates
    'text!templates/modules/setting/business/modals/payment-expired-group-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, U, Toastr,
    // services
    User,
    i18n,
    API,
    // views
    VModal,
    //templates
    TPaymentExpiredGroupModal
) {
    var VPaymentExpiredGroupModal = VModal.extend({
        template: TPaymentExpiredGroupModal,

        modal: function() {
            var buttons = {
                closeModal: {
                    label: i18n.t('Cancel'),
                    callback: this.onCancel
                }
            };
            if (this.options.isOwner) {
                buttons.ok = {
                    label: this.options.modalOptions.buttonText,
                    callback: this.onContinue
                };
            }

            return {
                closeButton: false,
                title: i18n.t("payment:expired_group_title"),
                message: this.options.modalOptions.message,
                size: 'medium',
                buttons: buttons
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            if (this.options.useClassicSite) {
                this.options.modalOptions = {
                    buttonText: i18n.t("Go to classic site"),
                    message: i18n.t("messages:message-group-expired-message")
                };
            } else {
                this.options.modalOptions = {
                    buttonText: i18n.t("payment:continue_with_payment_button"),
                    message: Mustache.render(this.template, Mustache.getContext({ canManagePayments: this.options.isOwner }))
                };
            }
        },

        render: function() {
            var self = this;
            User.fetch().done(function() {
                self.generateZones();
                self.renderModal();
            });
        },

        show: function(model) {
            this.render();
        },

        ////////////
        // events //
        ////////////
        onContinue: function(confirmed) {
            if (this.options.useClassicSite) {
                window.location.replace(window.env.OLD_ORIGIN + 'member/profile/');
            } else {
                if(this.options.teamPaymentModel && this.options.teamPaymentModel.get('payment')) {
                    var url = API.url("payments/team/" + this.options.teamPaymentModel.get('payment').id);

                    Backbone.ajax(
                        _.extend({
                            url: url,
                            method: "DELETE",
                            dataType: "json",
                            contentType: "application/json",
                            context: this,
                        }, {
                            error: function(jqXHR, textStatus, errorThrown) {
                                Toastr.error(
                                    i18n.t("payment:deleting_payment_method_error_message"),
                                    i18n.t("payment:deleting_payment_method_error_title"), {
                                        positionClass: "toast-top-center",
                                        newestOnTop: false,
                                        showMethod: "slideDown",
                                        tapToDismiss: false,
                                        closeButton: true
                                    }
                                );

                                this.close();

                                Backbone.history.redirect("#/");
                            },
                            success: function(response, textStatus, jqXHR) {
                                this.options.teamPaymentModel.deletePayment();

                                this.close();

                                Backbone.history.redirect("#/payment/modifyMethod/");
                            },
                        })
                    );

                    //Keep dialog open until payment method is deleted
                    return false;
                } else {
                    Backbone.history.redirect("#/payment/modifyMethod/");
                }
            }
        },

        onCancel: function() {
            Backbone.history.redirect("auth/logout");
            this.close();
        },
    });

    return VPaymentExpiredGroupModal;
});

